$(document)
    .on("shopify:section:load", function (e) {
        $("#" + e.target.id)
            .find("[data-section]")
            .sectionJs();
    })
    .ready(function () {
        $("[data-section]").each(function () {
            $(this).sectionJs();
        });
    }),
    ($.fn.sectionJs = function () {
        var e = this;
        "headerscript" == e.data("section") ? e.headerscript() : "sliderone" == e.data("section") && e.find(".home1-slider").sliderone();
    }),
    ($.fn.headerscript = function () {
        $(".mega_dropdown").parent("ul").addClass("mega-menu d-block"), $(".drop_item").parent("ul").addClass("sub-menu"), $(".multi_item").parent("ul").addClass("sub-menu");
    }),
    ($.fn.sliderone = function () {
        new Swiper(".hero-slider.swiper-container", {
            loop: !0,
            speed: 1e3,
            effect: "fade",
            autoplay: { delay: 7e3, disableOnInteraction: !1 },
            pagination: { el: ".swiper-pagination", clickable: !0 },
            navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        });
    }),
    (function (l) {
        "use strict";
        jQuery(document).ready(function () {
            l(".dropdown").on("show.bs.dropdown", function () {
                l(this).find(".dropdown-menu").first().stop(!0, !0).slideDown();
            }),
                l(".dropdown").on("hide.bs.dropdown", function () {
                    l(this).find(".dropdown-menu").first().stop(!0, !0).slideUp();
                }),
                l(".search-btn").on("click", function () {
                    l(this).toggleClass("active"), l(".dropdown_search").slideToggle("medium");
                }),
                l("#ageree_term_cond").on("click", function () {
                    l(this).parent(".cart-box-product").toggleClass("disabled");
                }),
                l("#cart_button_agree").on("click", function () {
                    l(this).parent(".proceed-to-checkout").toggleClass("disabled");
                }),
                l("#popup_ageree_term_cond").on("click", function () {
                    l(this).parent(".modal-button").toggleClass("disabled");
                }),
                l(window).on("scroll", function (e) {
                    250 < l(window).scrollTop() + 1 ? l(".sticky-nav").addClass("menu_fixed animated fadeInDown") : l(".sticky-nav").removeClass("menu_fixed animated fadeInDown");
                }),
                l("select.shop-sort").niceSelect(),
                l(".venobox").venobox();
            l(window);
            var s,
                i,
                n,
                e,
                a,
                t = l("body");
            (o = l(".offcanvas-toggle")),
                (s = l(".offcanvas")),
                (i = l(".offcanvas-overlay")),
                (n = l(".mobile-menu-toggle")),
                o.on("click", function (e) {
                    e.preventDefault();
                    var s = l(this),
                        e = s.attr("href");
                    t.addClass("offcanvas-open"), l(e).addClass("offcanvas-open"), i.fadeIn(), s.parent().hasClass("mobile-menu-toggle") && s.addClass("close");
                }),
                l(".offcanvas-close, .offcanvas-overlay").on("click", function (e) {
                    e.preventDefault(), t.removeClass("offcanvas-open"), s.removeClass("offcanvas-open"), i.fadeOut(), n.find("a").removeClass("close");
                }),
                (e = l(".offcanvas-menu, .overlay-menu")).find(".sub-menu").parent().prepend('<span class="menu-expand"></span>'),
                e.on("click", "li a, .menu-expand", function (e) {
                    var s = l(this);
                    ("#" !== s.attr("href") && !s.hasClass("menu-expand")) ||
                        (e.preventDefault(),
                        s.siblings("ul:visible").length
                            ? (s.parent("li").removeClass("active"), s.siblings("ul").slideUp(), s.parent("li").find("li").removeClass("active"), s.parent("li").find("ul:visible").slideUp())
                            : (s.parent("li").addClass("active"),
                              s.closest("li").siblings("li").removeClass("active").find("li").removeClass("active"),
                              s.closest("li").siblings("li").find("ul:visible").slideUp(),
                              s.siblings("ul").slideDown()));
                }),
                (a = l(".offcanvas-userpanel")).find(".user-sub-menu").parent().prepend('<span class="offcanvas__user-expand"></span>'),
                a.on("click", "li a, .offcanvas__user-expand", function (e) {
                    var s = l(this);
                    ("#" !== s.attr("href") && !s.hasClass("offcanvas__user-expand")) ||
                        (e.preventDefault(),
                        s.siblings("ul:visible").length
                            ? (s.parent("li").removeClass("active"), s.siblings("ul").slideUp(), s.parent("li").find("li").removeClass("active"), s.parent("li").find("ul:visible").slideUp())
                            : (s.parent("li").addClass("active"),
                              s.closest("li").siblings("li").removeClass("active").find("li").removeClass("active"),
                              s.closest("li").siblings("li").find("ul:visible").slideUp(),
                              s.siblings("ul").slideDown()));
                });
            new Swiper(".category-slider.swiper-container", {
                loop: !0,
                slidesPerView: 5,
                spaceBetween: 30,
                speed: 1500,
                autoplay: { delay: 7e3, disableOnInteraction: !1 },
                breakpoints: { 0: { slidesPerView: 2 }, 478: { slidesPerView: 2 }, 576: { slidesPerView: 2 }, 768: { slidesPerView: 3 }, 992: { slidesPerView: 4 }, 1200: { slidesPerView: 5 } },
            }),
                new Swiper(".blog-slider.swiper-container", {
                    loop: !0,
                    slidesPerView: 3,
                    spaceBetween: 30,
                    speed: 1500,
                    navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
                    breakpoints: { 0: { slidesPerView: 1 }, 478: { slidesPerView: 1 }, 576: { slidesPerView: 1 }, 768: { slidesPerView: 2 }, 992: { slidesPerView: 2 }, 1200: { slidesPerView: 3 } },
                });
            var o = new Swiper(".gallery-thumbs", { spaceBetween: 10, slidesPerView: 4, freeMode: !0, watchSlidesVisibility: !0, watchSlidesProgress: !0 }),
                o =
                    (new Swiper(".gallery-top", { spaceBetween: 0, loop: !0, navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }, thumbs: { swiper: o } }),
                    new Swiper(".zoom-thumbs", { spaceBetween: 10, slidesPerView: 4, freeMode: !0, watchSlidesVisibility: !0, watchSlidesProgress: !0 })),
                o =
                    (new Swiper(".zoom-top", { spaceBetween: 0, navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }, thumbs: { swiper: o } }),
                    new Swiper(".zoom-thumbs-2", { spaceBetween: 0, slidesPerView: 4, direction: "vertical", freeMode: !0, watchSlidesVisibility: !0, watchSlidesProgress: !0 }));
            new Swiper(".zoom-top-2", { spaceBetween: 0, loop: !0, navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }, thumbs: { swiper: o } });
            l(".zoom-image-hover").zoom();
            o = l(".cart-plus-minus");
            o.prepend('<div class="dec qtybutton">-</div>'),
                o.append('<div class="inc qtybutton">+</div>'),
                l(".qtybutton").on("click", function () {
                    var e = l(this),
                        s = e.parent().find("input").val();
                    (s = "+" === e.text() ? parseFloat(s) + 1 : 1 < s ? parseFloat(s) - 1 : 1), e.parent().find("input").val(s);
                });
            new Swiper(".single-product-slider", {
                slidesPerView: 4,
                spaceBetween: 20,
                speed: 1500,
                loop: !0,
                navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
                breakpoints: { 0: { slidesPerView: 1 }, 478: { slidesPerView: 1 }, 576: { slidesPerView: 2 }, 768: { slidesPerView: 3 }, 992: { slidesPerView: 3 }, 1024: { slidesPerView: 4 }, 1200: { slidesPerView: 4 } },
            });
            l(".checkout-toggle2").on("click", function () {
                l(".open-toggle2").slideToggle(1e3);
            }),
                l(".checkout-toggle").on("click", function () {
                    l(".open-toggle").slideToggle(1e3);
                }),
                l.scrollUp({ scrollText: '<i class="ion-android-arrow-up"></i>', easingType: "linear", scrollSpeed: 900, animation: "fade" }),
                l("[data-countdown]").each(function () {
                    var s = l(this),
                        e = l(this).data("countdown");
                    s.countdown(e, function (e) {
                        s.html(
                            e.strftime(
                                '<span class="cdown day"><span class="cdown-1">%-D</span><p>Days</p></span> <span class="cdown hour"><span class="cdown-1">%-H</span><p>Hours</p></span> <span class="cdown minutes"><span class="cdown-1">%M</span> <p>Mins</p></span> <span class="cdown second"><span class="cdown-1"> %S</span> <p>Sec</p></span>'
                            )
                        );
                    });
                });
            new Swiper(".blog-post-media", { slidesPerView: 1, spaceBetween: 0, loop: !0, navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" } });
            l(".product-color li label").click(function () {
                var e = jQuery(this).parent().find(".hidden a").attr("href");
                return jQuery(this).parents(".product-wrapper").find(".popup_cart_image").attr({ src: e }), !1;
            });
        });
    })(jQuery);
